import { render, staticRenderFns } from "./TitleCityPlace.vue?vue&type=template&id=0dd47d68&"
import script from "./TitleCityPlace.vue?vue&type=script&lang=js&"
export * from "./TitleCityPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports